import React from "react";
import HeaderImg from "../assets/images/careers/headerImg.webp";

const Careers = () => {
  return (
    <section className="w-[100%] max-w-screen-2xl mx-auto">
      <div className="relative w-full h-[30vh] xs:h-[35vh] small:h-[40vh] md:h-[50vh] lg:h-[55vh] xl:h-[60vh]">
        <img
          src={HeaderImg}
          alt="Lens Technologies header pic with girl smiling with specs on from back to front"
          className="w-[100%] h-[100%] object-cover"
        />
      </div>
      <div className="pt-8 flex flex-col px-custom-padding">
        <h1 className="text-2xl text-primary font-bold">
          Explore Life at Clearviz
        </h1>
        <div className="flex flex-col gap-4 py-4 text-15pt text-black leading-loose w-[98%]">
          Eyegear is a dynamic company that understands quality eyewear as per
          the needs of customers everywhere. We are always looking to hire
          talented professionals who speak the language of our customers. We
          pride ourselves on our committed and diverse work culture that
          believes in nurturing client relationships that go beyond optical
          sales. Moreover, our multi-branded retail outlets boast of a pan-India
          presence, making it a convenient shopping experience for our
          customers. By joining the company’s diversified workforce, come and
          make a difference to the future of our business—and your career!
        </div>
        <div className="flex flex-col py-4">
          <h2 className="text-lg text-primary font-medium">
            Our Values: Why we are unique
          </h2>
          <div className="flex flex-col gap-4 mt-2">
            <p className="text-15pt text-black leading-loose w-[98%]">
              We are proud of our caring, dynamic and responsive team who put
              customers first. Our team members work together to embrace the
              company’s ethical practices that are aligned with our business
              goals. Our mission is to empower employees to know they are part
              of something unique in the retail optical industry. That’s why at
              Eyegear, our team values workplace morale, growth and loyalty to
              drive the business forward.
            </p>
            <p className="text-15pt text-black leading-loose w-[98%]">
              We strive to create a safe and supportive workplace and encourage
              visionary thinking and leadership development at all levels. The
              most rewarding thing is to see our employees derive job enrichment
              and grow their career with us. By fostering an inclusive and
              collaborative atmosphere, we are paving the way for a positive
              work culture.
            </p>
          </div>
        </div>
        <div className="flex flex-col py-4">
          <h2 className="text-lg text-primary font-medium">
            A Culture of Learning and Rewards
          </h2>
          <div className="flex flex-col gap-4 mt-2">
            <p className="text-15pt text-black leading-loose w-[98%]">
              We seek to hire smart and talented professionals who pursue their
              goals passionately and responsibly. Our leadership team supports
              each employee’s professional and personal aspirations and provides
              adequate resources, on-job training, coaching and mentoring to
              help them stand apart from the crowd. Eyegear offers employees
              ample opportunities to contribute their best life at work by
              aligning their career goals with the company’s strategic mission.
              We champion our employees and help them flourish in a competitive
              environment by enhancing their skill-sets and product knowledge.
              It is why we seek team members who are driven and passionate about
              self-improvement.
            </p>
            <p className="text-15pt text-black leading-loose w-[98%]">
              Our company thrives on a culture that encourages job rotation and
              cross-functionality upskilling. We offer continuous learning in
              terms of career progression by providing real-time feedback,
              succession planning and performance improvement plans that empower
              individuals to reach their optimum as professionals in a
              modern-day workplace.
            </p>
            <p className="text-15pt text-black leading-loose w-[98%]">
              Most importantly, the company prides itself in recognizing and
              rewarding employees for great work done.
            </p>
          </div>
        </div>
        <div className="py-8">
          <a
            className="bg-primary text-white px-6 py-2 rounded-md font-medium transition-all hover:bg-primary/90"
            href="mailto:careers@eyegear.com"
          >
            Email Your CV
          </a>
        </div>
      </div>
    </section>
  );
};

export default Careers;
